import { makeQueryStringDync, toFormUrlEncoded, errorHandlerMiddleware, setHeader } from "../../helper.js";
let controller =  null;

const actions = {
  contentList: (context, payload) => {
    return new Promise((resolve, reject) => {

      if ( !payload.endpoint ) {
        reject(false)
        return false;
      }
      let categoryPayload = JSON.parse(JSON.stringify(payload));
      if (categoryPayload?.params?.category) {
        categoryPayload.params.category = encodeURIComponent(JSON.stringify(categoryPayload?.params?.category));
      }
      if (categoryPayload?.params?.notincontentprovider) {
        categoryPayload.params.notincontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notincontentprovider));
      }
      if (categoryPayload?.params?.incontentprovider) {
        categoryPayload.params.incontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.params?.incontentprovider));
      }
      if (categoryPayload?.params?.ingenre) {
        categoryPayload.params.ingenre = encodeURIComponent(JSON.stringify(categoryPayload?.params?.ingenre));
      }
      if (categoryPayload?.params?.notingenre) {
        categoryPayload.params.notingenre = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notingenre));
      }
      if (categoryPayload?.params?.notin) {
        categoryPayload.params.notin = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notin));
      }
      if (categoryPayload?.params?.orderby) {
        categoryPayload.params.orderby = encodeURI(JSON.stringify(categoryPayload?.params?.orderby));
      } 

      let data = makeQueryStringDync(categoryPayload.params, true);
      fetch(`${context.getters.vCmsBaseUrl}${categoryPayload.endpoint}${data}`, {
        method: "GET",
        headers: setHeader(null, null, true)
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentList(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  contentListMetaCall: (context, payload) => {
    return new Promise((resolve, reject) => {

      let data = makeQueryStringDync(payload.params, true);
      fetch(`${context.getters.vCmsBaseUrl}${payload.endpoint}${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentList(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listContent: (context, payload) => {
    return new Promise((resolve, reject) => {
      let categoryPayload = JSON.parse(JSON.stringify(payload));
      if (categoryPayload?.notincontentprovider) {
        categoryPayload.notincontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.notincontentprovider));
      }
      let data = makeQueryStringDync(categoryPayload, true);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listGenerContent: (context, payload) => {
    return new Promise((resolve, reject) => {
      let data = makeQueryStringDync(payload, true);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/genre${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listBundleItem: (context, payload) => {
    return new Promise((resolve, reject) => {
      let data = JSON.stringify(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/?contentlist=${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listBundleItem(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getContent: (context, payload) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/${payload}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.getContent(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  contentDetail: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let objectId;

      if (typeof payload == "object") {
        objectId = payload.contentid;
      } else {
        objectId = payload;
      }
      let queryUrl = `${context.getters.vCmsBaseUrl}subscriber/v1/content/${objectId}`;

      if (payload.params) {
        let dataParams = makeQueryStringDync(payload.params, true);
        queryUrl += dataParams;
      }

      let isAnonymousUser = localStorage.getItem("loginType") ? false : true;
      let headerObj;

      if (isAnonymousUser == true) {
        headerObj = {
          Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        };
      } else {
        headerObj = {
          "X-SESSION": `${localStorage.getItem("subscriberToken")}`,
        };
      }
      fetch(queryUrl, {
        method: "GET",
        headers: setHeader(null, null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentDetail(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => reject(error));
    });
  },
  listSuggestions: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryStringDync(payload, true);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/suggestions${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listSuggestions(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  contentSearch: (context, payload) => {
    console.log("payload==>", payload)
    if (controller || payload.query === "") {
      controller.abort();
    }
    controller = new AbortController(); 

    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let categoryPayload = JSON.parse(JSON.stringify(payload));
      if (categoryPayload?.notincontentprovider) {
        categoryPayload.notincontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.notincontentprovider));
      }
      if (categoryPayload?.ingenre) {
        categoryPayload.ingenre = encodeURIComponent(JSON.stringify(categoryPayload?.ingenre));
      }
      if (categoryPayload?.notingenre) {
        categoryPayload.notingenre = encodeURIComponent(JSON.stringify(categoryPayload?.notingenre));
      }
      let data = makeQueryStringDync(categoryPayload, true);
      
      fetch(`${context.getters.vCmsBaseUrl}${context.getters.appConfig.apiUtilities.searchEndpoint}${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),
        signal: controller.signal
        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentSearch(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  genreList: (context) => {
    return new Promise((resolve, reject) => {
      // if (!payload) {
      //   reject({ error: "payload not found" });
      // }
      // let data = makeQueryStringDync(payload);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/genre`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.genreList(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  genreContentList: (context, payload) => {

    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      // let data = makeQueryStringDync(payload);
      fetch(
        `${context.getters.vCmsBaseUrl}subscriber/v1/content?category=["${payload.category}"]&objecttype=${payload.objecttype}&genre=${payload.genre}&objectlanguage=["${payload.objectlanguage}"]&productionyear=${payload.productionyear}&pagesize=30`,
        {
          method: "GET",
          headers: setHeader(null, null, true),

          // {
          //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
          // },
        }
      )
        .then((response) => errorHandlerMiddleware(response, () => actions.genreContentList(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //get content stream url//
  contentStreamUrl: (context, payload) => {
    console.log('contentStreamUrl_payload', payload)
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = toFormUrlEncoded(payload.params);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/package/${payload.contentid}`, {
        method: "POST",
        body: data,
        headers: setHeader("formUrl", null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.contentStreamUrl(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  //list related contents//
  relatedContents: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let categoryPayload = JSON.parse(JSON.stringify(payload));
      if (categoryPayload?.params?.category) {
        categoryPayload.params.category = encodeURIComponent(JSON.stringify(categoryPayload?.params?.category));
      }
      if (categoryPayload?.params?.notincontentprovider) {
        categoryPayload.params.notincontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notincontentprovider));
      }
      if (categoryPayload?.params?.incontentprovider) {
        categoryPayload.params.incontentprovider = encodeURIComponent(JSON.stringify(categoryPayload?.params?.incontentprovider));
      }
      if (categoryPayload?.params?.ingenre) {
        categoryPayload.params.ingenre = encodeURIComponent(JSON.stringify(categoryPayload?.params?.ingenre));
      }
      if (categoryPayload?.params?.notingenre) {
        categoryPayload.params.notingenre = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notingenre));
      }
      if (categoryPayload?.params?.notin) {
        categoryPayload.params.notin = encodeURIComponent(JSON.stringify(categoryPayload?.params?.notin));
      }
      if (categoryPayload?.params?.orderby) {
        categoryPayload.params.orderby = encodeURI(JSON.stringify(categoryPayload?.params?.orderby));
      } 
      let data = makeQueryStringDync(categoryPayload.params, true);
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/content/related/${payload.contentid}${data}`, {
        method: "GET",
        headers: setHeader(null, null, true),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.relatedContents(context, payload)))

        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  listi18nLanguage: (context) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vSmsBaseUrl}subscriberv2/v1/i18n/language`, {
        method: "GET",
        headers: setHeader(),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`,
        // },
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.listi18nLanguage(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  authorizeCurrentStreamApi: (context) => {
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/authorize`, {
        method: "GET",
        headers: setHeader(null, null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentStreamApi: (context, payload) => {
    let data = toFormUrlEncoded(payload.params);

    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/${payload.contentId}`, {
        method: "POST",
        body: data,
        headers: setHeader(null, null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  actGetDRMToken: (context, payload) => {
    return new Promise((resolve, reject) => {
      // let baseUrl = 'https://vcms-ses.mobiotics.com/prodv3/'
      // let endPoint = 'subscriber/v2/content/drmtoken'
      fetch(`${context.getters.vDrmTokenUrlV2}`, {
        method: "POST",
        body: payload,
        headers: setHeader('formUrl', null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  unsetCurrentStreamApi: (context, payload) => {

    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vCmsBaseUrl}subscriber/v1/stream/content/${payload.contentId}`, {
        method: "DELETE",
        headers: setHeader(null, null, true),
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.authorizeCurrentStreamApi(context)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  userRecommendations: (context, payload) => {
    // console.log("payload", payload)
    let params = payload.params ? payload.params : {};
    let data = makeQueryStringDync(params, false, true);
    // console.log("urlllll", `${context.getters.vRecommendationBaseUrl}${context.getters.appConfig.apiUtilities.vRecommendations}${data}`)
    // "https://6f34o218c2.execute-api.us-east-1.amazonaws.com/betav1/v1/recommendations/vRecommendations?country=IN&ruleid=6842e19a0839a200082de044&page=1"
    https://zpb21m2p2i.execute-api.us-east-1.amazonaws.com/prodv1/v1/recommendations/topRecommendations?country=IN&ruleid=684d9fe48270e50008f4186c
    // https://6f34o218c2.execute-api.us-east-1.amazonaws.com/betav1v1/recommendations/vRecommendations?ruleid=684be4bfc18dd000083c4686&page=1&devicetype=PC&deviceos=MACOS&visitingcountry=IN&homecountry=AR&profileage=23
    return new Promise((resolve, reject) => {
      fetch(`${context.getters.vRecommendationBaseUrl}/${payload.endpoint}${data}`, {
        method: "GET",
        headers: setHeader(null, null, false),

        // {
        //   Authorization: `Bearer ${localStorage.getItem("subscriberToken")}`
        // }
      })
        .then((response) => errorHandlerMiddleware(response, () => actions.userRecommendations(context, payload)))
        .then((data) => {
          resolve({ data });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  actions,
};
